module.exports = __webpack_public_path__ + "static/media/car-roof.314215dc.svg";